import { useState } from 'react';
import type { DeleteUserRequest, DeleteUserResponse } from 'vopay';
import { api } from '@/services/api.config';

export default function useDeleteUser() {
  const [submitting, setSubmitting] = useState(false);

  async function deleteUser(params: DeleteUserRequest): Promise<DeleteUserResponse> {
    try {
      setSubmitting(true);
      const res = await api.postDeleteUser(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error('Delete user failed:', error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, deleteUser };
}
